import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import AnimatedBackground from './components/AnimatedBackground';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProgramPage from './pages/ProgramPage';
import ProjectMapPage from './pages/ProjectMapPage';
import GostsPage from './pages/GostsPage';
import TasksPage from './pages/TasksPage';
import ContactsPage from './pages/ContactsPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
};

const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <div
      key={pathname}
      style={{
        animation: 'fadeInUp 0.4s ease',
      }}
    >
      {children}
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div style={{ minHeight: '100vh', background: '#0a0a14', position: 'relative' }}>
          <AnimatedBackground />
          <Navbar />
          <main style={{ position: 'relative', zIndex: 1 }}>
            <Routes>
              <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
              <Route path="/program" element={<PageTransition><ProgramPage /></PageTransition>} />
              <Route path="/project-map" element={<PageTransition><ProjectMapPage /></PageTransition>} />
              <Route path="/gosts" element={<PageTransition><GostsPage /></PageTransition>} />
              <Route path="/tasks" element={<PageTransition><TasksPage /></PageTransition>} />
              <Route path="/contacts" element={<PageTransition><ContactsPage /></PageTransition>} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
